import { E_RISK_TYPE, VIEW } from 'interfaces';
import React from 'react';
import GQMapProvider from 'components/GQMap/GQMapProvider';
import useInitCountryDim from 'hooks/useInitCountryDim';
import { FGStack, FGTypography } from '@fg/design-system';
import RightArrow from 'assets/svg/arrow_right.svg?react';
import { IMobxRootState } from 'RootStore';
import { inject } from 'mobx-react';
import { size } from 'lodash';

export const RiskViewPage = React.memo(() => {
    return <RiskView />;
});

export const RiskView = React.memo(() => {
    const ready = useInitCountryDim({
        riskType: E_RISK_TYPE.DIMENSIONS,
        multiCountry: true,
        multiRisk: false,
    });

    if (!ready) return null;
    return (
        //todo: after refactoring - make sure these container divs are still necessary
        <div
            style={{
                width: '100%',
                height: '100%',
                position: 'relative',
            }}>
            <div
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                <Header />
                <div style={{ flex: 1, minHeight: 0 }}>
                    <GQMapProvider view={VIEW.RISK_VIEW} hideToolbar />
                </div>
                <Legend />
            </div>
        </div>
    );
});

const Legend = React.memo(() => {
    return (
        <div style={{ marginTop: 37, marginBottom: 48, marginLeft: 25 }}>
            <FGStack alignItems="center" gap={8}>
                <LegendLabel>Low Risk (0)</LegendLabel>
                <RightArrow />
                <LegendLabel>High Risk (100)</LegendLabel>
                <div style={{ width: 48 }} />
                <LegendLabel>Falling Risk</LegendLabel>
                <Gradient />
                <LegendLabel>Rising Risk</LegendLabel>
            </FGStack>
        </div>
    );
});

const LegendLabel = React.memo(
    ({ children }: { children: React.ReactNode }) => {
        return (
            <FGTypography variant="captions" tag="label" color="strong">
                {children}
            </FGTypography>
        );
    }
);

const Gradient = React.memo(() => {
    return (
        <div
            style={{
                width: 80,
                height: 12,
                background:
                    'linear-gradient(-90deg, #570000 0%, #F22 28.85%, #028254 68.75%, #65FFCC 100%)',
            }}
        />
    );
});

const Header = inject(({ countryStore }: IMobxRootState) => ({
    countryCount: size(countryStore.countries?.licensedCountriesArr),
}))(
    React.memo(({ countryCount }: { countryCount?: number }) => {
        return (
            <FGStack direction="column" style={{ padding: 16 }}>
                <FGTypography variant="headline4" tag="h4" color="strong">
                    Political Risk at a Glance
                </FGTypography>
                <FGTypography variant="body3-long" tag="label">
                    {`${countryCount} countries scored daily. Click to explore.`}
                </FGTypography>
            </FGStack>
        );
    })
);
